<ng-container *ngIf="{ state: workspacePullProgressService.pullState$ | async } as ctx">
  <mat-toolbar *ngIf="hasRemoteChanges || isRunning(ctx.state)" class="mc-toolbar-normal mc-border-radius-normal mc-toolbar-outer-spacing-large" [class.mc-workspace-pull-changes-bar-remote-start-pulse]="remoteStartPulse" color="caution">
    <mat-icon class="mc-centered-text-icon" fontSet="project-titan" fontIcon="icon-warning-filled"></mat-icon>
    <span class="mc-toolbar-spacer-small"></span>
    <ng-container *ngIf="isRunning(ctx.state); else externalChangesText">
      <ng-container *ngIf="pullingUser$ | async as pullingUser; else pullingNoUser">
        <span>Pulling changes. Started by&nbsp;</span>
        <mc-license-user-avatar [licenseUser]="pullingUser" size="small" compact="text"></mc-license-user-avatar>
      </ng-container>
      <ng-template #pullingNoUser>
        <span>Pulling changes.</span>
      </ng-template>
      <span class="mc-toolbar-spacer-small"></span>
      <span>{{ pullingLabel(ctx.state) }}</span>
    </ng-container>
    <ng-template #externalChangesText>External commits have been detected.</ng-template>

    <ng-container *ngIf="!readonly">
      <span class="mc-fill-remaining-flex-space"></span>

      <button mat-flat-button class="mc-toolbar-item-full mc-toolbar-item-full-end mc-border-top-right-radius-normal mc-border-bottom-right-radius-normal mc-workspace-pull-change-bar-pull-button" color="caution" (click)="onPullChangesClicked()">
        <ng-container *ngIf="isRunning(ctx.state); else pullChangesText">View Progress</ng-container>
        <ng-template #pullChangesText>Pull Changes</ng-template>
      </button>
    </ng-container>
  </mat-toolbar>
</ng-container>